export const EntityTypes = [
  { value: 'sole', label: 'Sole Proprietorship' },
  {
    value: 'partnership',
    label: 'General Partnership'
  },
  { value: 'corporation', label: 'Corporation' },
  { value: 'llc', label: 'Limited Liability Company' }
];
